export const BASE_URL = "https://api.meegloo.com/";

export const API_CONFIG = {
    BASE_URL,
    COMPANY_SERVICES: `${BASE_URL}restapicompany-services`,
    CONTRACTOR_TYPES: `${BASE_URL}restapi/contractor-types`,
    REGISTER: `${BASE_URL}restapi/register`,
    GET_OTP: `${BASE_URL}restapi/getotp`,
    VERIFY_OTP: `${BASE_URL}restapi/verifyotp`,
    USER_PROFILES: `${BASE_URL}restapi/userprofiles`,
    CITIES: `${BASE_URL}restapi/cities`,
    STATES: `${BASE_URL}restapi/states`,
    PLOTS: `${BASE_URL}restapi/plot-servicereqs`,
    PLOT_SERVICE_REQS: `${BASE_URL}restapi/plot-service-reqs`,
    FILE_UPLOAD: `${BASE_URL}restapi/files/upload`,
    COMPANY_PROFILES_POST: `${BASE_URL}restapi/company-profiles`,
    COMPANY_RATES: `${BASE_URL}restapi/companyrates`,
    PLOT_FILES: `${BASE_URL}restapi/plot-files`,
    COMPANY_RATES_UPDATE: (id: number) => `${BASE_URL}restapi/companyrates/${id}`,
    COMPANY_PROFILES: (page: number, size: number) => `${BASE_URL}restapi/company-profiles?page=${page}&size=${size}`,
    COMPANY_PROFILE_BY_ID: (id: string) => `${BASE_URL}restapi/company-profiles/${id}`,
    COMPANY_PROFILE: (userProfileId: number | null) =>
        `${BASE_URL}restapi/company-profiles?userProfileId.equals=${userProfileId}`,
    RATE_CARD_TYPES: `${BASE_URL}restapi/rate-card-types?page=0&size=20`,
    RATE_CARD_ITEMS: (rateCardTypeId: number) =>
        `${BASE_URL}restapi/rate-card-items?rateCardTypesId.equals=${rateCardTypeId}&page=0&size=20`,
    COMPANY_PLOT_CONSTRUCTION_STAGES: (companyProfileId: number, plotId: number, page: number, size: number) =>
        `${BASE_URL}restapi/company-plot-constructionstages?companyProfileId=${companyProfileId}&plotId=${plotId}&page=${page}&size=${size}`,
    COMPANY_PROFILE_RATES_BY_ID: (id: string) => `${BASE_URL}restapi/companyrates/${id}`,
    COMPANY_PROFILE_RATES_POST: `${BASE_URL}restapi/company-plot-constructionstages`,
    CONTACT_US: `${BASE_URL}restapi/contactuses`,
    SUBSCRIBE_EMAILS: `${BASE_URL}restapi/subscribe-emails`,
    SYSTEM_CONFIGS: `${BASE_URL}restapi/system-configs`,
    PLOT_RATE_CARDS: `${BASE_URL}restapi/plot-ratecards/plot-all-ratecards`,
    APPROVE_RATECARDS: `${BASE_URL}restapi/plot-ratecards/approve-ratecards`,
    
    PAYMENT_URL: `${BASE_URL}restapi/payment`,
    PLOT_SERVICE_REQ: `${BASE_URL}restapi/services-reqs`,
    PLOT_SERVICE_REQS_MAIN: `${BASE_URL}restapi/plot-servicereqs`,
    BOOKING_PAYMENT:`${BASE_URL}restapi/payment/bookingPayment`,
    PAYMENT_APPROVE: (id: string) => `${BASE_URL}restapi/payment/${id}`
};  